export const columns = [
  {
    title: 'page_tenant_operation',
    key: 'action',
    width: 90,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: '查看',
    key: 'read',
    width: 90,
    scopedSlots: { customRender: 'read' }
  },
  {
    title: "应用id",
    dataIndex: "clientId",
    key: "clientId",
    ellipsis: true,
  },
  {
    title: "应用密钥",
    dataIndex: "clientSecret",
    key: "clientSecret",
    ellipsis: true,
  },
  {
    title: "授权类型",
    dataIndex: "authorizedGrantTypes",
    key: "authorizedGrantTypes",
    width: 300,
  },
  {
    title: "授权范围",
    dataIndex: "scope",
    key: "scope",
    ellipsis: true,
  },
  {
    title: "令牌秒数",
    dataIndex: "accessTokenValidity",
    key: "accessTokenValidity",
    ellipsis: true,
  },
]
